import styled, { css } from 'styled-components';

import { fontSizes, fontWeights } from '../../../theme';
import { DataTableCellEditor } from '../primitives';
import { DataTableCellEditorVariableNames } from '../primitives/DataTableCellEditor/constants';

const variableStyles = css({
  [DataTableCellEditorVariableNames.FontWeight]: fontWeights.medium,
  [DataTableCellEditorVariableNames.FontSize]: fontSizes.m,
});

const DataTableHighlightedCellEditor = styled(DataTableCellEditor)`
  ${variableStyles}
`;

export default DataTableHighlightedCellEditor;
